// extracted by mini-css-extract-plugin
export default {"customBtn":"UserModal_customBtn__x-r6S","name":"UserModal_name__byBXp","email":"UserModal_email__1SgT+","id":"UserModal_id__0+tHR","textarea":"UserModal_textarea__nIPmo"};